import { Background } from '../components/layout/Background';

// backgroundSlot: renders between the CSS background and the z-10 content wrapper.
// Use it for layered canvas/animation backgrounds (e.g. SandstormBackground).
export function HomeLayout({ children, backgroundSlot }) {
  return (
    <div className="relative h-screen overflow-hidden">
      <Background />
      {backgroundSlot}
      <div className="relative z-10 h-full flex flex-col">
        {children}
      </div>
    </div>
  );
}
